import { Box, HStack, Header } from '@rbilabs/universal-components';
import { withTypography } from 'ucl/components/text/Typography';

export const EntryDescriptionRow = withTypography({
  m: '$0',
  variant: 'copyTwo',
  style: { width: '100%' },
});

export const Item = Box.withConfig({
  flexDirection: 'row',
  alignItems: 'baseline',
  flexWrap: 'wrap',
  padding: 0,
  marginBottom: '$1',
});

export const ItemHeader = HStack.withConfig({
  justifyContent: 'space-between',
  width: 'full',
  alignItems: 'flex-start',
  marginBottom: '$1',
});

export const ItemName = Header.withConfig({
  variant: 'headerFour',
  margin: 0,
  flexBasis: '80%',
  flexShrink: 1,
});

export const ItemPrice = Box.withConfig({
  width: '1/6',
  justifyContent: 'center',
  flexShrink: 0,
  flexGrow: 0,
  textAlign: 'right',
});
